import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import arrowRightIcon from '../../../assets/images/arrow-right-circle-outline.svg';
import Hyperlink from '../../common/Hyperlink';

const SpecialOfferWrapper = styled(Hyperlink)`
  background-color: var(--c-ral);
  border-radius: var(--fr);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(2 * var(--fr));
  transition-duration: 0.33s;
  transition-property: background-color, background-color;

  &:hover {
    background-color: var(--c-charcoal);
  }

  h4 {
    margin-bottom: 0;
  }

  > div {
    flex: 1;
  }

  > *:not(:last-child) {
    margin-right: var(--fr);
  }

  .description {
    color: var(--c-manatee);
    margin-top: calc(var(--fr) / 2);
  }

  .icon {
    width: 24px;
    height: 24px;
  }
`;

const SpecialOffer = ({
  title,
  description,
  to,
  className,
  openInNewTab,
  trackingTitle,
  onClick,
}) => {
  return (
    <SpecialOfferWrapper
      to={to}
      className={className}
      openInNewTab={openInNewTab}
      onClick={() => onClick(trackingTitle)}
    >
      <div>
        <h4>{title}</h4>
        <div className="description">{description}</div>
      </div>
      <img src={arrowRightIcon} className="icon" alt="" />
    </SpecialOfferWrapper>
  );
};

SpecialOffer.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
  openInNewTab: PropTypes.bool,
  trackingTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SpecialOffer;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/plans/SpecialOffer.js